import { useLocation, useNavigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useState, useEffect } from "react";
import { HELP_IDS } from "@/lib/help-ids";

function LiveClock() {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => { setTime(new Date()); }, 1000);
    return () => { clearInterval(id); };
  }, []);
  return (
    <span className="text-xs text-muted-foreground tabular-nums flex items-center gap-1.5" data-help-id={HELP_IDS.topbar.clock}>
      <span className="relative flex h-1.5 w-1.5" aria-hidden="true">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
        <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-green-500" />
      </span>
      <span className="sr-only">Live</span>
      {time.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })}
    </span>
  );
}

/**
 * Minimal top bar — logo + "SpecTree" branding on the left, live clock on the right.
 */

export function TopBar() {
  const location = useLocation();
  const navigate = useNavigate();

  const segments = location.pathname.split("/").filter(Boolean);
  const isRoot = segments.length <= 1;

  return (
    <header className="flex items-center justify-between h-14 mt-4 shrink-0">
      <div className="flex items-center">
        {/* Back arrow — inline, same left edge as content */}
        {!isRoot && (
          <button
            onClick={() => { void navigate(-1); }}
            aria-label="Go back"
            data-help-id={HELP_IDS.topbar.backButton}
            className="flex items-center justify-center h-7 w-7 rounded-lg text-muted-foreground hover:text-foreground hover:bg-white/[0.06] transition-colors shrink-0 mr-3"
          >
            <ArrowLeft className="h-4 w-4" />
          </button>
        )}

        {/* Logo + section title */}
        <Link
          to="/dashboard"
          data-help-id={HELP_IDS.topbar.logo}
          className="flex items-center gap-2 min-w-0"
        >
          <img src="/toro-logo.svg" alt="SpecTree" className="h-7 shrink-0" />
          <span className="text-base font-semibold text-foreground" style={{ fontFamily: "'Golos Text', sans-serif" }}>
            SpecTree
          </span>
        </Link>
      </div>

      <LiveClock />
    </header>
  );
}
